<template>
  <div class="counterparties-add_form" v-if="editableClient || !isEdit">
    <div class="counterparties-add_block">
      <h2 class="counterparties-add_block__title svg-white-dart">
        <svg width="12" height="12" viewBox="0 0 12 12" style="transform:translateY(-1px)" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.9828 4.62409C11.9414 4.4968 11.8314 4.40404 11.699 4.38482L7.97896 3.84424L6.31525 0.473304C6.25605 0.353304 6.13382 0.277344 6.00002 0.277344C5.86619 0.277344 5.74399 0.353304 5.68476 0.473304L4.02099 3.84424L0.301004 4.38482C0.168606 4.40404 0.058567 4.4968 0.0172234 4.62407C-0.0241436 4.75136 0.0103562 4.89107 0.106192 4.98447L2.79793 7.60838L2.16259 11.3134C2.13995 11.4453 2.19418 11.5786 2.30244 11.6573C2.36368 11.7018 2.43622 11.7244 2.50911 11.7244C2.56508 11.7244 2.62124 11.7111 2.67266 11.684L6 9.93471L9.32719 11.684C9.44567 11.7463 9.58918 11.7359 9.69744 11.6573C9.80569 11.5786 9.85995 11.4453 9.83733 11.3134L9.20178 7.60838L11.8938 4.98444C11.9896 4.89107 12.0242 4.75136 11.9828 4.62409Z"
            fill="#2C2C2C" />
        </svg>
        Counterparty Types
      </h2>

      <!-- <counterparties-drop 
        :class="{ 'block-input_error': $v.selectType.$error }"
        ref="dropType" 
        :list="clientsType" 
        :activeItem="editableClient.type"
        @select="selectedType" 
        title="Type" 
        :isDisabled="isDisableTypeDrop" 
      /> -->
      <async-select :label="'Type'" :error="$v.editableClient.type.$error" v-model="editableClient.type"
        :allowEmpty="true" :closeOnSelect="true" :isMultiple="false" url="/client/type" :placeholder="''"
        @on-select="editableClient.subtype = ''" :params="{ ordering: 'name', is_archived: false }"
        watchKey="name"></async-select>
      <div class="error" v-if="!$v.editableClient.type.required && $v.editableClient.type.$dirty">Field is required
      </div>

      <async-select class="m-t-3" :label="'SubType'" :key="JSON.stringify(editableClient.type)"
        v-model="editableClient.subtype" :allowEmpty="true" :closeOnSelect="true" :isMultiple="false"
        url="/client/type/subtype" :placeholder="''"
        :isDisabled="editableClient.type == null || editableClient.type == undefined"
        :params="{ ordering: 'name', is_archived: false, main_type: editableClient.type ? editableClient.type.id : null }"
        watchKey="name"></async-select>
      <!-- <counterparties-drop 
        ref="dropSubtype"
        :list="subtypeDepend" 
        :activeItem="editableClient.subtype"
        :isMultiple="true" 
        :isSelectedPrev="!!selectType && !!selectType.name" 
        @select="selectedSubtype" 
        :isDisabled="isDisableTypeDrop"
        title="SubType" 
      /> -->
      <counterparties-edit-types />
    </div>

    <div class="counterparties-add_block">
      <h2 class="counterparties-add_block__title svg-white-dart">
        <svg width="12" height="12" viewBox="0 0 12 12" style="transform:translateY(-1px)" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM6 5C6.55228 5 7 5.44772 7 6V9C7 9.55228 6.55228 10 6 10C5.44772 10 5 9.55228 5 9V6C5 5.44772 5.44772 5 6 5ZM6 4C6.55228 4 7 3.55228 7 3C7 2.44772 6.55228 2 6 2C5.44772 2 5 2.44772 5 3C5 3.55228 5.44772 4 6 4Z"
            fill="#2C2C2C" />
        </svg>
        About
      </h2>

      <label class="block-input" :class="{ 'block-input_error': $v.name.$error }">
        <p class="block-input_title text-gray">Company Name</p>
        <input class="block-input_content" type="text" maxlength="255" v-model.trim="$v.name.$model"
          @input="forceUpperName($event)">
        <div class="error" v-if="!$v.name.required && $v.name.$dirty">Field is required</div>
        <div class="error" v-if="!$v.name.minLength">Name must have at least {{ $v.name.$params.minLength.min }}
          letters.
        </div>
        <div class="error" v-if="!$v.name.maxLength">Name must have at max {{ $v.name.$params.maxLength.max }} letters.
        </div>
      </label>

      <label class="block-input">
        <p class="block-input_title text-gray">Common name</p>
        <input class="block-input_content" type="text" maxlength="255" v-model="charterName">
      </label>

      <!-- <counterparties-drop 
        ref="dropBroker"
        :list="brokers" 
        :activeItem="editableClient.broker"
        :isMultiple="true" 
        @select="selectedBroker" 
        title="Broker"
      ></counterparties-drop> -->
      <async-select class="m-t-3" :isMultiple="true" id="counterpart32y" label="Broker" url="/client/dropdown"
        :placeholder="''" :params="{ is_archived: false, ordering: 'company_name' }" watchKey="company_name"
        :allowEmpty="true" :closeOnSelect="false" v-model="editableClient.broker" />

      <label class="block-input">
        <p class="block-input_title text-gray">Country, City</p>
        <input class="block-input_content" type="text" maxlength="255" v-model="location">
      </label>

      <label class="block-input" :class="{ 'block-input_error': $v.fullStyle.$error }">
        <p class="block-input_title text-gray">Full Style</p>
        <textarea class="block-input_content" rows="3" maxlength="2000" v-model="$v.fullStyle.$model"></textarea>
        <div class="error" v-if="!$v.fullStyle.maxLength">Name must have at max {{ $v.fullStyle.$params.maxLength.max }}
          letters.</div>
      </label>

      <async-select-port class="m-t-3" id="port_select" v-model="selectPort" label="Port" :isMultiple="true"
        :allowEmpty="true" :closeOnSelect="false" />

      <label class="block-input">
        <p class="block-input_title text-gray">Comment</p>
        <textarea class="block-input_content" rows="3" maxlength="2000" v-model="comment"></textarea>
      </label>

      <label class="block-input tags">
        <p class="block-input_title text-gray">Tag</p>
        <tag-select ref="tagsSel" @emitGetTags="selectedTag"></tag-select>
      </label>
    </div>

    <div class="counterparties-add_block">
      <h2 class="counterparties-add_block__title svg-white-dart">
        <svg width="12" height="12" viewBox="0 0 12 12" style="transform:translateY(1px)" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M10.2609 0H1.73913C0.778635 0 0 0.766502 0 1.71203V7.93241C0 8.87794 0.778635 9.64444 1.73913 9.64444H2.23188V11.657C2.23188 11.9308 2.54202 12.0938 2.77313 11.9416L6.26087 9.64444H10.2609C11.2214 9.64444 12 8.87794 12 7.93241V1.71203C12 0.766502 11.2214 0 10.2609 0ZM2.26087 3.795C2.26087 3.49558 2.50744 3.25286 2.81159 3.25286H9.24638C9.55053 3.25286 9.7971 3.49558 9.7971 3.795C9.7971 4.09442 9.55053 4.33714 9.24638 4.33714H2.81159C2.50744 4.33714 2.26087 4.09442 2.26087 3.795ZM3.97101 5.42143C3.66686 5.42143 3.42029 5.66416 3.42029 5.96357C3.42029 6.26299 3.66686 6.50572 3.97101 6.50572H8.08696C8.39111 6.50572 8.63768 6.26299 8.63768 5.96357C8.63768 5.66416 8.39111 5.42143 8.08696 5.42143H3.97101Z"
            fill="#2C2C2C" />
        </svg>
        Contact Details
      </h2>

      <div class="counterparties-add_block_content" v-for="(contact, i) in contacts" :key="i">
        <label class="block-input">
          <p class="block-input_title text-gray">Contact Name</p>
          <input class="block-input_content" type="text" maxlength="255" v-model.trim="contact.name">
        </label>

        <label class="block-input" :class="{ 'block-input_error': $v.contacts.$each[i].email.$error }">
          <p class="block-input_title text-gray">Email</p>
          <input class="block-input_content" type="email" maxlength="255" v-model.trim="contact.email">
        </label>
        <div class="error" v-if="$v.contacts.$each[i].email.$error">Must be a valid email</div>

        <label class="checkbox">
          <input type="checkbox" v-model="contact.send_invoice">
          <div class="checkbox_custom">
            Send invoices to this email address
          </div>
        </label>

        <label class="block-input" :class="{ 'block-input_error': $v.contacts.$each[i].phone.$error }">
          <p class="block-input_title text-gray">Telephone</p>
          <input class="block-input_content" type="tel" maxlength="255" ref="phone" v-model.trim="contact.phone">
        </label>
        <div class="error" v-if="$v.contacts.$each[i].phone.$error">Must be a valid phone</div>

        <label class="block-input" :class="{ 'block-input_error': $v.contacts.$each[i].fax.$error }">
          <p class="block-input_title text-gray">Fax</p>
          <input class="block-input_content" type="tel" maxlength="255" ref="fax" v-model.trim="contact.fax">
        </label>
        <div class="error" v-if="$v.contacts.$each[i].fax.$error">Must be a valid fax</div>

        <div class="counterparties-add_block_content__control">
          <button class="counterparties-add_block_content__control_btn" @click="deleteContact(i, contact)"
            v-if="contacts.length > 1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M10.6364 4.36585C10.5073 4.36585 10.4091 4.46907 10.4091 4.58852V5.26399H13.5909V4.58852C13.5909 4.46907 13.4927 4.36585 13.3636 4.36585L10.6364 4.36585ZM14.9545 5.26399V4.58852C14.9545 3.70768 14.2387 3 13.3636 3L10.6364 3C9.76125 3 9.04545 3.70768 9.04545 4.58852V5.26399H5.18182C4.80526 5.26399 4.5 5.56975 4.5 5.94692C4.5 6.32409 4.80526 6.62984 5.18182 6.62984H6.31818V16.5059C6.31818 17.8869 7.441 19 8.81818 19H15.1818C16.559 19 17.6818 17.8869 17.6818 16.5059V6.62984H18.8182C19.1947 6.62984 19.5 6.32409 19.5 5.94692C19.5 5.56975 19.1947 5.26399 18.8182 5.26399H14.9545ZM7.68182 6.62984V16.5059C7.68182 17.1255 8.18706 17.6341 8.81818 17.6341H15.1818C15.8129 17.6341 16.3182 17.1255 16.3182 16.5059V6.62984H7.68182ZM10.6364 8.88637C11.0129 8.88637 11.3182 9.19213 11.3182 9.5693V14.5501C11.3182 14.9272 11.0129 15.233 10.6364 15.233C10.2598 15.233 9.95455 14.9272 9.95455 14.5501V9.5693C9.95455 9.19213 10.2598 8.88637 10.6364 8.88637ZM13.3636 8.88637C13.7402 8.88637 14.0455 9.19213 14.0455 9.5693V14.5501C14.0455 14.9272 13.7402 15.233 13.3636 15.233C12.9871 15.233 12.6818 14.9272 12.6818 14.5501V9.5693C12.6818 9.19213 12.9871 8.88637 13.3636 8.88637Z"
                fill="#094172" />
            </svg>
            Delete contact
          </button>
          <button class="counterparties-add_block_content__control_btn" @click="addNewContact"
            v-if="i == contacts.length - 1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.3333 11.3333H12.6667V6.66662C12.6667 6.2987 12.368 6 11.9999 6C11.632 6 11.3333 6.2987 11.3333 6.66662V11.3333H6.66662C6.2987 11.3333 6 11.632 6 11.9999C6 12.368 6.2987 12.6667 6.66662 12.6667H11.3333V17.3333C11.3333 17.7013 11.632 18 11.9999 18C12.368 18 12.6667 17.7013 12.6667 17.3333V12.6667H17.3333C17.7013 12.6667 18 12.368 18 11.9999C18 11.632 17.7013 11.3333 17.3333 11.3333Z"
                fill="#094172" />
            </svg>
            Add new contact
          </button>
        </div>
      </div>
    </div>

    <div class="counterparties-add_block">
      <h2 class="counterparties-add_block__title">
        <span class="fz0 svg-white-dart">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.81714 5.24404C7.81714 5.24404 8.42603 4.69122 7.85011 4.1153C7.27419 3.53938 6.68813 4.11501 6.68813 4.11501L5.68395 5.11927C4.6723 6.13131 4.54743 7.65226 5.55898 8.66343C6.57104 9.67547 8.12742 9.58595 9.13867 8.57399L10.8329 6.88058C12.3891 5.3244 12.3891 2.79201 10.8329 1.23584L10.7648 1.16773C9.20778 -0.389243 6.67539 -0.389243 5.11918 1.16773L1.16743 5.11898C-0.389145 6.67515 -0.389145 9.20754 1.16743 10.7645L1.23555 10.8326C2.44731 12.0441 4.26942 12.333 5.80734 11.5801C6.22019 11.3781 6.66887 10.9953 6.37271 10.4585C6.05937 9.89059 5.50893 10.0143 5.2179 10.147C4.34939 10.5048 3.06902 10.4078 2.36458 9.70372L2.29646 9.6348C1.3624 8.70155 1.3624 7.18197 2.29646 6.24793L6.24821 2.29665C7.18227 1.36259 8.70183 1.36259 9.6351 2.29665L9.704 2.36477C10.6373 3.29883 10.6373 4.8176 9.704 5.75166L8.00971 7.44507C7.62066 7.83411 7.07703 7.92366 6.68799 7.53451C6.29894 7.14536 6.42391 6.63737 6.81296 6.24822L7.81714 5.24404Z"
              fill="#2C2C2C" />
          </svg>
        </span>
        Attachments

        <label class="counterparties-add_block_content__control_btn btn_add-file">
          <input type="file" multiple @change="addFiles">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M17.3333 11.3333H12.6667V6.66662C12.6667 6.2987 12.368 6 11.9999 6C11.632 6 11.3333 6.2987 11.3333 6.66662V11.3333H6.66662C6.2987 11.3333 6 11.632 6 11.9999C6 12.368 6.2987 12.6667 6.66662 12.6667H11.3333V17.3333C11.3333 17.7013 11.632 18 11.9999 18C12.368 18 12.6667 17.7013 12.6667 17.3333V12.6667H17.3333C17.7013 12.6667 18 12.368 18 11.9999C18 11.632 17.7013 11.3333 17.3333 11.3333Z"
              fill="#094172" />
          </svg>
          Attach new file
        </label>
      </h2>

      <div class="counterparties-add_block_attachments">
        <div class="counterparties-add_block_attachment" v-for="(file, i) in attachments" :key="file.id">
          <counterparties-file-option-btn :file="file" @edit-item="editFile(file, i)"
            @delete-item="deleteFile(file.id)" />
          <img @click="openViewer(i)" class="counterparties-add_block_attachment-img"
            :src="file.thumbnail ? file.thumbnail : file.file" :alt="file.name" v-if="getAllowFile(file)">
          <svg @click="openViewer(i)" class="counterparties-add_block_attachment-img" v-else width="48" height="48"
            viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6.83985 48H41.1598C42.8167 48 44.1598 46.6569 44.1598 45V13.44L30.7198 0H6.83984C5.18299 0 3.83984 1.34315 3.83984 3V45C3.83984 46.6569 5.18299 48 6.83985 48Z"
              fill="#DEE3EA" />
            <path
              d="M44.1602 13.4414L33.7202 13.4414C32.0633 13.4414 30.7202 12.0983 30.7202 10.4414L30.7202 0.00140549L36.8002 6.18381L44.1602 13.4414Z"
              fill="#BDCBD6" />
            <path
              d="M12.0527 22.7051H15.0352C16.293 22.7051 17.2734 23.0742 17.9766 23.8125C18.6836 24.5508 19.0371 25.5859 19.0371 26.918C19.0371 28.2539 18.6855 29.2949 17.9824 30.041C17.2793 30.7871 16.2969 31.1602 15.0352 31.1602H12.0527V22.7051ZM13.3652 23.8359V30.0234H14.9121C15.8105 30.0234 16.498 29.7578 16.9746 29.2266C17.4551 28.6953 17.6953 27.9297 17.6953 26.9297C17.6953 25.9336 17.4551 25.1699 16.9746 24.6387C16.4941 24.1035 15.8066 23.8359 14.9121 23.8359H13.3652ZM23.9473 22.5645C25.1621 22.5645 26.125 22.957 26.8359 23.7422C27.5508 24.5273 27.9082 25.5918 27.9082 26.9355C27.9082 28.2793 27.5527 29.3438 26.8418 30.1289C26.1309 30.9102 25.166 31.3008 23.9473 31.3008C22.7285 31.3008 21.7637 30.9102 21.0527 30.1289C20.3418 29.3438 19.9863 28.2793 19.9863 26.9355C19.9863 25.5918 20.3418 24.5273 21.0527 23.7422C21.7637 22.957 22.7285 22.5645 23.9473 22.5645ZM23.9473 23.7188C23.1426 23.7188 22.5039 24.0078 22.0312 24.5859C21.5625 25.1641 21.3281 25.9473 21.3281 26.9355C21.3281 27.9199 21.5625 28.7012 22.0312 29.2793C22.5039 29.8574 23.1426 30.1465 23.9473 30.1465C24.748 30.1465 25.3828 29.8574 25.8516 29.2793C26.3242 28.7012 26.5605 27.9199 26.5605 26.9355C26.5605 25.9473 26.3242 25.1641 25.8516 24.5859C25.3828 24.0078 24.748 23.7188 23.9473 23.7188ZM32.7305 31.3008C31.543 31.3008 30.5996 30.9082 29.9004 30.123C29.2051 29.3379 28.8574 28.2734 28.8574 26.9297C28.8574 25.5938 29.207 24.5332 29.9062 23.748C30.6055 22.959 31.5469 22.5645 32.7305 22.5645C33.6914 22.5645 34.502 22.8359 35.1621 23.3789C35.8223 23.918 36.207 24.627 36.3164 25.5059H35.0156C34.8984 24.9629 34.6309 24.5293 34.2129 24.2051C33.7988 23.877 33.3047 23.7129 32.7305 23.7129C31.9609 23.7129 31.3457 24.0059 30.8848 24.5918C30.4277 25.1738 30.1992 25.9531 30.1992 26.9297C30.1992 27.918 30.4277 28.7031 30.8848 29.2852C31.3418 29.8633 31.959 30.1523 32.7363 30.1523C33.3223 30.1523 33.8145 30.0098 34.2129 29.7246C34.6152 29.4395 34.8828 29.041 35.0156 28.5293H36.3223C36.1621 29.4043 35.7656 30.0859 35.1328 30.5742C34.5039 31.0586 33.7031 31.3008 32.7305 31.3008Z"
              fill="#094172" />
          </svg>
          <p class="counterparties-add_block_attachment-text" tabindex="0" ref="fileText"
            @blur="blurEditable($event, file)" :class="{ 'editable': file.editable }" :contenteditable="true"
            v-if="file.name">{{ file.name }}</p>
          <p class="counterparties-add_block_attachment-text" v-else>{{ file.file }}</p>
        </div>
      </div>

      <file-viewer ref="fileViewer" :files="attachments" @change-name="changeFileName" @delete-file="deleteFile" />

      <div class="error" v-if="$v.$error">Please fill the form correctly.</div>
    </div>

    <!-- <pre>{{$v.contacts.$each}}</pre> -->

    <modal-del :contact="delContact" v-if="isEdit && isModalDelOpen" @close="closeModalDel"
      @update="deleteContact"></modal-del>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email, helpers } from 'vuelidate/lib/validators'
const phone_validator = helpers.regex('phone_validator', /^(\+)?(\d{1,2})?[( .-]*(\d{3})[) .-]*(\d{3,4})[ .-]?(\d{4})$/)

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

// import counterpartiesDrop from '@/components/counterparties/counterpartiesAdd/counterpartiesDrop'
import counterpartiesEditTypes from '@/components/counterparties/counterpartiesAdd/counterpartiesEditTypes'
import TagSelect from '@/components/tasks/tasks-list/task-list-tag-select'
import modalDel from '@/components/counterparties/counterpartiesAdd/counterpartiesModalDelContact'
import counterpartiesFileOptionBtn from '@/components/counterparties/counterpartiesUser/counterpartiesFileOptionBtn'
import fileViewer from '@/components/counterparties/counterpartiesUser/fileViewer'
import asyncSelectPort from '@/components/reuse/asyncSelectPort'
import AsyncSelect from '@/components/reuse/asyncSelect'

export default {
  mixins: [validationMixin],
  components: {
    counterpartiesEditTypes,
    TagSelect,
    modalDel,
    counterpartiesFileOptionBtn,
    fileViewer,
    asyncSelectPort,
    AsyncSelect,
  },
  props: {
    insideBlockTypeModal: {
      type: Boolean
    },
    bus: {},
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isModalDelOpen: false,
      delContact: {
        i: '',
        contact: {}
      },
      selectType: {},
      selectSubtype: [],
      selectBroker: [],
      selectPort: [],
      selectTag: [],
      name: '',
      charterName: '',
      location: '',
      fullStyle: '',
      comment: '',
      contacts: [],
      attachments: [],
      editableClient: {},
      allowFormats: [".jpeg", ".png", ".raw", ".jpg", ".jfif", ".tiff", ".bmp", ".gif", "jp2", ".svg"],
    }
  },
  validations: {
    name: {
      required,
      maxLength: maxLength(255),
      minLength: minLength(1)
    },
    fullStyle: {
      maxLength: maxLength(2000),
    },
    editableClient: {
      type: { required }
    },
    contacts: {
      $each: {
        email: {
          email
        },
        phone: {
          phone_validator
        },
        fax: {
          phone_validator
        }
      }
    }
  },
  computed: {
    ...mapState({
      clientsType: state => state.counterpartiesType.clientsType,
      clientsSubtype: state => state.counterpartiesType.clientsSubtype,
      brokers: state => state.counterparties.brokers,
    }),
    ...mapGetters(['getClientById']),
    subtypeDepend() {
      if (!this.editableClient.type) return []
      let subtypes = this.clientsSubtype.filter(elem => {

        return this.editableClient.type.id == elem.parent_id
      })
      return subtypes
    },
    isDisableTypeDrop() {
      if (this.isEdit && this.selectSubtype.findIndex(el => el == 19) >= 0)
        return true
      return false
    },
  },
  methods: {
    ...mapActions(["axiosGetBrokers", "axiosGetClientsById", "axiosGetClientsForDropdown", "axiosGetPaymentCash", 'axiosAddClient', 'axiosEditClient', 'axiosGetClients', 'FileAdd', 'axiosUpdateFile', 'axiosFileDelete', 'axiosGetClientsType', 'axiosGetClientsSubtype']),
    ...mapMutations(['showLoad', 'hideLoad']),
    selectedType(type) {
      this.selectType = type
      this.$v.editableClient.type.$touch()

      // clear subtipes
      this.editableClient.subtype = null
      this.$refs.dropSubtype.render()
    },
    selectedSubtype(arrOfTypes) {
      this.selectSubtype = []
      if (!arrOfTypes) return false
      arrOfTypes.forEach(type => {
        this.selectSubtype.push(type.id)
      });
    },
    selectedBroker(arrOfBrokers) {
      if (!arrOfBrokers) return false
      this.selectBroker = []
      arrOfBrokers.forEach(broker => {
        this.selectBroker.push(broker.id)
      });
    },
    selectedPort(arrOfPorts) {
      console.log('selectedPort-', arrOfPorts);
      /* if(!arrOfPorts) return false
      this.selectPort = []
      arrOfPorts.forEach(port => {
        this.selectPort.push(port.id)
      }); */
    },
    selectedTag(data) {
      //console.log(data);
      this.selectTag = data
    },
    addNewContact() {
      this.contacts.push({
        name: '',
        email: '',
        send_invoice: false,
        phone: '',
        fax: '',
      })
    },
    deleteContact(i, contact) {

      if (this.isEdit && !this.isModalDelOpen && contact && Object.keys(contact).includes('id')) {
        this.delContact.i = i
        this.delContact.contact = contact
        this.isModalDelOpen = true
        return false
      }

      this.contacts.splice(i, 1)

      this.closeModalDel()
    },
    clearData() {
      this.name = ''
      this.charterName = ''
      this.location = ''
      this.fullStyle = ''
      this.comment = ''
      this.editableClient.type = {}
      this.selectSubtype = []
      this.editableClient.broker = []
      this.selectPort = []
      this.selectTag = []
      if (this.$refs.dropType)
        this.$refs.dropType.render()
      if (this.$refs.dropSubtype)
        this.$refs.dropSubtype.render()
      if (this.$refs.dropBroker)
        this.$refs.dropBroker.render()
      this.contacts = [
        {
          name: '',
          email: '',
          send_invoice: true,
          phone: '',
          fax: '',
        }
      ]
    },
    async addClient() {
      if (!this.validateClient())
        return false

      this.$refs.tagsSel.getTagsForAxios();
      this.showLoad()
      let newClientId
      await this.axiosAddClient({
        company_name: this.name,
        charter_name: this.charterName,
        location: this.location,
        full_style: this.fullStyle,
        comment: this.comment,
        type: this.editableClient.type ? this.editableClient.type.id : null,
        subtype: Array.isArray(this.editableClient.subtype) ? this.editableClient.subtype.map(item => { return item.id }) : (this.editableClient.subtype ? [this.editableClient.subtype.id] : []),
        broker: this.editableClient.broker,
        port: this.selectPort ? this.selectPort.map(el => el.id) : [],
        tags: this.selectTag,
        contacts: this.contacts.filter(contact => {
          if (contact.name || contact.email || contact.phone || contact.fax) {
            return contact
          }
        }),
        attachments: this.attachments ? this.attachments.map(el => el.id) : []
      }).then((response) => {
        newClientId = response.data.id;
        // this.axiosGetPaymentCash();
        this.axiosGetClientsForDropdown()

      })
      await this.axiosGetClients().then(() => {
        //this.clearData()
        if (!this.insideBlockTypeModal) {
          if (this.$route.query.from == 'vessels') {
            if (this.$route.query.vessel) {
              if (this.$route.query.subcontract) {
                if (this.$route.query.subcontract == 'voyage') { // create contract
                  this.$router.push(`/vessels/${this.$route.query.vessel}/open/charterers?from=counterparties&newcharterer=voyage`)
                } else if (this.$route.query.subcontract == 'sublet') { // create contract
                  this.$router.push(`/vessels/${this.$route.query.vessel}/open/charterers?from=counterparties&newcharterer=sublet`)
                } else // edit contract
                  this.$router.push(`/vessels/${this.$route.query.vessel}/open/charterers/${this.$route.query.subcontract}/details?from=counterparties`)
              } else // edit vessel
                this.$router.push(`/vessels/${this.$route.query.vessel}/open/detail/?from=counterparties`)
            } else // create vessel
              this.$router.push('/vessels/actual/?from=counterparties')
          } else if (this.$route.query.from == 'workspace') {
            this.$router.push(`/vessel-task/${this.$route.query.id}/workspace/?from=counterparties&id=${this.$route.query.rowid}&index=${this.$route.query.index}`)
          } else
            this.$router.push('/counterparties/' + newClientId)
        }
      })
      this.$emit('close')
      this.hideLoad()
    },
    editClient() {
      if (!this.validateClient())
        return false

      this.$refs.tagsSel.getTagsForAxios();
      this.showLoad()
      this.axiosEditClient({
        id: this.editableClient.id,
        company_name: this.name,
        charter_name: this.charterName,
        location: this.location,
        full_style: this.fullStyle,
        comment: this.comment,
        type: this.editableClient.type ? this.editableClient.type.id : null,
        subtype: Array.isArray(this.editableClient.subtype) ? this.editableClient.subtype.map(item => { return item.id }) : (this.editableClient.subtype ? [this.editableClient.subtype.id] : []),
        broker: this.selectBroker,
        port: this.selectPort ? this.selectPort.map(el => el.id) : [],
        tags: this.selectTag,
        contacts: this.contacts.filter(contact => {
          if (contact.name || contact.email || contact.phone || contact.fax) {
            return contact
          }
        }),
        attachments: this.attachments ? this.attachments.map(el => el.id) : []
      }).then(() => {
        this.clearData()
        this.hideLoad()
        this.$router.push('/counterparties')
      })
    },
    async setDataIfEdit() {
      let client = this.getClientById(this.$route.params.id)[0]
      // let client = this.axiosGetClientById(this.$route.params.id)

      if (client == undefined || client == null) {
        this.showLoad()
        client = await this.axiosGetClientsById(this.$route.params.id)
        this.hideLoad()
      }
      console.log(client)
      this.editableClient = client
      this.name = this.editableClient.company_name
      this.charterName = this.editableClient.charter_name
      this.location = this.editableClient.location
      this.fullStyle = this.editableClient.full_style
      this.comment = this.editableClient.comment

      if (this.editableClient.contacts.length) {
        this.contacts = this.editableClient.contacts
      } else {
        this.addNewContact()
        this.contacts[0].send_invoice = true
      }

      this.$refs.tagsSel.setTags(this.editableClient)

      //console.log('adsfdsfasd ---', this.editableClient.files);
      this.attachments = this.editableClient.files
    },
    validateClient() {
      this.$v.$touch()
      if (this.$v.$invalid)
        return false
      return true
    },
    closeModalDel() {
      this.isModalDelOpen = false
    },

    async addFiles(e) {
      if (e.target.files) {
        let result = await this.FileAdd({ file: e.target.files })
        this.attachments = [...this.attachments, ...result]
      }
    },
    async deleteFile(id) {
      let index = this.attachments.findIndex(el => {
        return el.id == id
      })
      this.attachments.splice(index, 1)
      this.axiosFileDelete(id)
    },
    editFile(file, i) {
      // console.log('lol23', i);
      file.editable = true

      this.$nextTick().then(() => {
        this.$refs.fileText[i].focus()
      })
    },
    async blurEditable(e, file) {
      file.editable = false
      await this.axiosUpdateFile({ id: file.id, name: e.target.innerText })
      //this.client = await this.axiosGetClientsById(this.$route.params.id)
    },
    getAllowFile(file) {
      let fileType = file.file.substring(file.file.lastIndexOf("."))
      if (this.allowFormats.indexOf(fileType) >= 0) {
        return true
      }
      return false
    },
    async changeFileName([id, name]) {
      console.log('changeFileName', [id, name]);
      await this.axiosUpdateFile({ id, name })
      /* this.client.files.filter(file => {
        return file.id == id
      })[0].name = name */
    },
    openViewer(i) {
      this.$refs.fileViewer.showViewFileModal(i)
    },

    forceUpperName(e) {
      this.name = e.target.value.toUpperCase()
    }
  },
  async beforeMount() {
    this.axiosGetClientsType()
    await this.axiosGetClientsSubtype()
    if (!this.brokers.length) {
      let broketTypeId = this.clientsSubtype.find(el => el.name == 'Broker')
      if (broketTypeId) {
        this.axiosGetBrokers(broketTypeId.id)
      }
    }
  },
  async mounted() {
    if (this.isEdit) {
      this.setDataIfEdit()
    } else {
      this.addNewContact()
      this.contacts[0].send_invoice = true
    }
  },
  created() {
    this.bus.$on('addClient', () => {
      this.addClient()
    });
    this.bus.$on('editClient', () => {
      this.editClient()
    });
  },
}
</script>

<style lang="scss">
.counterparties-add {
  &_block {
    margin-top: 21px;

    &__title {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      font-size: 14px;
      font-weight: 500;

      svg {
        margin-right: 6px;
      }
    }

    &_content {
      &__control {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;

        &_btn {
          display: inline-flex;
          align-items: center;
          font-weight: 500;
          font-size: 14px;
          color: var(--color-blue-dark);

          svg {
            margin-right: 4px;

            path {
              fill: var(--color-blue-dark);
            }
          }

          &.btn_add-file {
            position: relative;
            margin-left: auto;
            cursor: pointer;

            input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              opacity: 0;
              cursor: pointer;
              font-size: 0;
            }
          }
        }
      }
    }

    .dropdown {
      position: relative;
      display: block !important;
    }

    .dropdown-menu {
      margin: 0;
    }

    .checkbox {
      margin-top: 6px;
      margin-bottom: -2px;
    }

    &_attachments {
      display: flex;
      flex-wrap: wrap;
    }

    &_attachment {
      position: relative;
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      width: 66px;
      margin-right: 8px;
      margin-bottom: 12px;
      font-size: 11px;
      line-height: 13px;

      &-img {
        width: 48px;
        height: 48px;
        object-fit: contain;
        margin-bottom: 4px;
      }

      &-text {
        margin: 0;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-all;
      }

      &:hover {
        .option-btn_wrap {
          opacity: 1;
        }
      }
    }

    .error {
      color: #E85353;
      font-size: 10px;
    }
  }
}

.block-input {
  display: block;
  margin-top: 14px;

  &_title {
    font-size: 13px;
    margin-bottom: 5px;
  }

  &_content {
    height: auto;
    padding: 9px 12px;
    font-size: 14px;
    line-height: 16px;
  }

  &_error {
    input.block-input_content {
      border-color: #E85353;
    }
  }
}

.checkbox {
  display: block;
  position: relative;

  &_custom {
    padding-left: 22px;
    padding: 4px 0 4px 22px;
    font-size: 13px;

    &:after,
    &:before {
      position: absolute;
      top: 2px;
      left: 0px;
      display: block;
      width: 16px;
      height: 16px;
      pointer-events: none;
      content: "";
      box-sizing: border-box;
    }

    &:before {
      background-color: #fff;
      border: 1px solid var(--color-border) !important;
      border-radius: 0.25rem;
      outline: none !important;
      box-shadow: none !important;
    }

    &:after {
      background: no-repeat 50% / 50% 50%;
    }
  }

  input {
    position: absolute;
    left: 0;
    z-index: -1;
    width: 1rem;
    height: 1.25rem;
    opacity: 0;

    &:checked~.checkbox_custom:before {
      border-color: var(--color-blue-dark) !important;
      background-color: var(--color-blue-dark);
    }

    &:checked~.checkbox_custom:after {
      background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e");
    }
  }
}

.tags {
  .button-drop {
    width: 100% !important;
    height: 36px !important;
    padding: 9px 12px;
  }
}
</style>